//import { getScript } from './_utils'

const $ = jQuery.noConflict();

export default class Layout {

  $offcanvasBtn: JQuery<HTMLElement> = $('.off-canvas-sidebar-trigger');
  $btn: JQuery<HTMLLinkElement> = $('#offcanvas-trigger');

  constructor () {
    this.setup();
  }

  setup():void{
    this.offcanvasTrigger();
  }

  offcanvasTrigger(): void{
    this.$btn.on('click', (event: JQuery.ClickEvent):void => {
      event.preventDefault();
      this.$offcanvasBtn.trigger('click');
    });
  }

}
